// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1_pkG","label":"Radio_label__3RtiR","checkMark":"Radio_checkMark__1UzFR","disabled":"Radio_disabled__ZJNHW"};